import { ValidationError } from "yup";

interface IValidationErrors {
  [key: string]: string;
}

export default function getValidationErrors(
  err: ValidationError
): IValidationErrors {
  const validationErros: IValidationErrors = {};
  err.inner.forEach((error) => {
    validationErros[error.path ?? ""] = error.message;
  });

  return validationErros;
}
